import { useTextes } from '@common/config';
import { Z_INT } from '../primitives';

const t = useTextes('Commun', 'Formulaire');

export const Z_EFFECTIF_APPRENTI = Z_INT(t['DETAIL_OFA_INFO_MODIF_MSG3']);

export const EFFECTIF_APPRENTI_PLACEHOLDER = '100';